/**
 * JS-Errors und Warnings loggen
 */
class HXSysmonLogJs {
    static instance = null;
    maxLogEntriesPerPage = 10; // max. Anzahl an Logeintraegen je Seite
    sentLogsEntriesCount  = 0; // akt. Anzahl an Logeintraegen der Seite
    processId = "";

    origError = console.error.bind(console);
    origWarn  = console.warn.bind(console);


    /**
     * @param {bool} logErrors
     * @param {bool} logWarnings
     */
    constructor(logErrors=true,logWarnings=true) {
        //HXSysymonLogJs singelton verhalten
        if (HXSysmonLogJs.instance) return HXSysmonLogJs.instance;

        if (logWarnings===true) this.initLogWarnings();
        if (logErrors===true) {
            this.initLogRunntimeErrors();
            this.initLogErrors();
            this.initLogUnhandledrejection();
        }

        //ProzessID generieren
        const min = 10_000_000_000; // smallest 11-digit number
        const max = 99_999_999_999; // largest 11-digit number
        this.processId =  Math.floor(Math.random() * (max - min + 1)) + min;

        HXSysmonLogJs.instance = this; //singleton
    }

    /**
     * Speichert Errors und Warnings
     * @param {sting} payload
     */
    sendLogToServer(payload) {
        // throttle: stop after maxPerPage logs for this page load
        if (this.sentLogsEntriesCount >= this.maxLogEntriesPerPage) return;
        this.sentLogsEntriesCount += 1;

        try {
            //sendBeacon ist robuster, asyncron als $.ajax plus keine Abh�ngigkeit von jQuery
            navigator.sendBeacon(
                $hxVar.root + "libhx/ajax/sysmon/log_js_errors.php",
                new Blob([JSON.stringify(payload)], { type: "application/json" })
            );

        } catch (e) {
            // sendBeacon not available or failed
        }
    }

    /**
     * Extrahiert  {file, line, column} vom error object oder stack string.
     * @param {Error|string|null} errorStack  Either an Error instance (preferred) or a stack string
     * @returns {{file: string|null, line: number|null, column: number|null}}
     */
    extractLocation(errorStack) {
        //Error object with structured properties
        if (errorStack && typeof errorStack === "object") {
            const err = errorStack;
            if ("fileName" in err || "lineNumber" in err || "columnNumber" in err) {
                return {
                    file:   err.fileName  || null,
                    line:   err.lineNumber != null ? err.lineNumber : null,
                    column: err.columnNumber != null ? err.columnNumber : null
                };
            }

            if (typeof err.stack === "string") {
                return this._extractFromStack(err.stack);
            }
        }

        if (typeof errorStack === "string") {
            return this._extractFromStack(errorStack);
        }

        return { file: null, line: null, column: null };
    }

    /**
     * Fallback-Parser f�r Stack-Strings.
     * Nutzt browser-spezifische Regex-Muster, um Datei/Zeile/Spalte zu extrahieren.
     */
    _extractFromStack(stack) {
        if (!stack) return { file: null, line: null, column: null };
        const lines = stack.split("\n");

        // Chrome/Edge: "at functionName (http://url:line:column)"
        // Firefox:     "functionName@http://url:line:column"
        const re = /\(?([^\s()@:]+):(\d+):(\d+)\)?$/;

        for (const line of lines) {
            const match = re.exec(line.trim());
            if (match) {
                return {
                    file:   match[1],
                    line:   parseInt(match[2], 10),
                    column: parseInt(match[3], 10)
                };
            }
        }

        return { file: null, line: null, column: null };
    }

    /**
     * Aktiv nur, wenn this.logErrors === true ist.
     * Faengt unbehandelte Exceptions ab (z. B. throw new Error("boom") ohne try/catch).
     * Erfasst Laufzeitfehler (z. B. Aufruf nicht definierter Funktionen).
     * Erfasst Ressourcen-Ladefehler (z. B. <script src="missing.js">).
     */
    initLogRunntimeErrors() {
        window.addEventListener("error", (event) => {
            const {message, filename, lineno, colno, error} = event;

            const payload = {
                level: "error",
                message: message || "",
                url: filename || "",
                line: lineno != null ? lineno : null,
                column: colno != null ? colno : null,
                stack: (error && error.stack) ? error.stack : null,
                timestamp: new Date().toISOString(),
                processid: this.processId
            };
            this.sendLogToServer(payload);
        });
    }

    /**
     * Erfasst nicht behandelte Promise-Ablehnungen
     * (z. B. fetch(...).then(...) ohne .catch).
     * Wird ausgeloest, wenn ein Promise abgelehnt wird
     * und kein .catch-Handler vorhanden ist.
     */
    initLogUnhandledrejection() {
        window.addEventListener("unhandledrejection", (event) => {
            try {
                let message = "";
                let stack = null;

                // The "reason" is what the Promise was rejected with
                if (event.reason instanceof Error) {
                    message = event.reason.message || "Unhandled rejection";
                    stack = event.reason.stack || null;
                } else if (typeof event.reason === "object") {
                    try {
                        message = JSON.stringify(event.reason);
                    } catch (e) {
                        message = String(event.reason);
                    }
                } else {
                    message = String(event.reason);
                }

                if (!stack) {
                    const errObj = new Error();
                    stack = errObj.stack || null;
                }

                const loc = this.extractLocation(stack);

                const payload = {
                    level: "error",
                    message: message,
                    url: loc.file || window.location.href,
                    line: loc.line,
                    column: loc.column,
                    stack: stack,
                    timestamp: new Date().toISOString(),
                    processid: this.processId
                };

                this.sendLogToServer(payload);
            } catch (e) {
                // Ignore logging failures
            }
        });
    }

    /**
     * Aktiv nur, wenn this.logWarnings === true ist.
     * Erfasst explizite console.warn("...") Aufrufe,
     * z. B. durch jQuery Migrate (kein natives Window-Event).
     */
    initLogWarnings() {
        console.warn = function () {
            let text;
            let stack = null;
            try {
                const args = Array.prototype.slice.call(arguments);
                text = args.map(function (a) {
                    if (a instanceof Error) {
                        if (a.stack) stack = a.stack;
                        return a.message;
                    }
                    return (typeof a === "object" && a !== null)
                        ? JSON.stringify(a)
                        : String(a);
                }).join(" ");

                if (!stack) {
                    const errObj = new Error();
                    stack = errObj.stack || null;
                }

                const loc = this.extractLocation(stack);

                const payload = {
                    level: "warn",
                    message: text,
                    url: loc.file || window.location.href,
                    line: loc.line,
                    column: loc.column,
                    stack: stack,
                    timestamp: new Date().toISOString(),
                    processid: this.processId
                };
                this.sendLogToServer(payload);
            } catch (e) {
                // ignore any failure in logging
            } finally {
                this.origWarn.apply(console, arguments);
            }
        }.bind(this);
    }

    /**
     * Aktiv nur, wenn this.logErrors === true ist.
     * Reagiert auf explizite Aufrufe von console.error("...").
     * Laufzeitfehler (Exceptions) werden damit nicht automatisch erfasst.
     */
    initLogErrors() {
        console.error = function () {
            let text;
            let stack = null;

            try {
                // 1. Format the message payload
                const args = Array.prototype.slice.call(arguments);
                text = args.map(function (a) {
                    if (a instanceof Error) {
                        // If they passed an Error object, capture its stack
                        if (a.stack) stack = a.stack;
                        return a.message;
                    }
                    return (typeof a === "object" && a !== null)
                        ? JSON.stringify(a)
                        : String(a);
                }).join(" ");

                // 2. If no Error object was passed, create one to capture a stack
                if (!stack) {
                    const errObj = new Error();
                    stack = errObj.stack || null;
                }

                // 3. Extract location from that stack
                const loc = this.extractLocation(stack);

                // 4. Build payload
                const payload = {
                    level:     "error",
                    message:   text,
                    url:       loc.file || window.location.href,
                    line:      loc.line,
                    column:    loc.column,
                    stack:     stack,
                    timestamp: new Date().toISOString(),
                    processid: this.processId
                };

                // 5. Send once

                this.sendLogToServer(payload);
            } catch (e) {
                // ignore any failure in logging
            } finally {
                // Always call the original so DevTools still shows it
                this.origError.apply(console, arguments);
            }
        }.bind(this);
    }
}

